<template>
    <div style="padding: 50px 18px 18px; ">
        <div class="row mb-2">
            <div class="col-12">
                <a href="javascript:void(0)" @click="close" class="float-left">&lt;&lt; Back to message</a>
            </div>
        </div>
        <b-alert variant="warning" dismissible v-model="showAlert"><div class="text-left"><h4 class="alert-heading">Warnings</h4>{{apiMessages}}</div></b-alert>
        <div class="form-inline">
            <div class="form-group mx-sm-3 mb-2">
                <label labelforid="inputClaimReference" class="sr-only">Claim Reference</label>
                <input type="text" class="form-control" id="inputClaimReference" v-model="claimReference" placeholder="Claim Reference" />
            </div>
            <button type="submit" class="btn btn-primary mb-2" @click="assignClick">
                <span v-if="showSpinner"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Loading...</span>
                <span v-else>Assign</span>
            </button>
        </div>
    </div>
</template>

<script>
    import EventBus from '@/messageEventBus.js';
    import { LINK_MESSAGE_TO_CLAIM, LINK_MESSAGE_TO_CLAIM_COMPLETE } from '@/messageEvents.js';

    export default {
        name: "assign-to-claim",
        props: {
            eventTarget: {
                type: String,
                required: true
            },
            messageId: {
                type: Number,
                required: true
            }
        },
        data: () => {
            return {
                showSpinner: false,

                apiMessages: null,
                showAlert: false,

                claimReference: ''
            };
        },
        methods: {
            assignClick() {
                //this.$emit("closePanel", this.claimReference)
                this.showSpinner = true
                EventBus.$emit(LINK_MESSAGE_TO_CLAIM + '_' + this.eventTarget, { claimReference: this.claimReference, messageId: this.messageId });
                EventBus.$once(LINK_MESSAGE_TO_CLAIM_COMPLETE + '_' + this.messageId, (payload) => {
                    console.log(LINK_MESSAGE_TO_CLAIM_COMPLETE + ' AssignToClaim: ', payload)
                    if (payload.messages != null) {
                        this.apiMessages = payload.messages
                        this.showAlert = true
                    }

                    this.showSpinner = false
                    this.$emit("closePanel", { closeCaller: true });
                    EventBus.$off(LINK_MESSAGE_TO_CLAIM_COMPLETE + '_' + this.messageId)
                });
            },
            close() {
                this.$emit("closePanel");
            }
        },
        mounted() {
            //EventBus.$on(LINK_MESSAGE_TO_CLAIM_COMPLETE, (payload) => {
            // console.log(LINK_MESSAGE_TO_CLAIM_COMPLETE + ' AssignToClaim: ', payload)
            // if (payload.messages != null) {
            //   this.apiMessages = payload.messages
            //   this.showAlert = true
            // }

            // this.showSpinner = false
            //});
        }
    };
</script>

